import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

function CaseStudyCard({ study }) {
  const navigate = useNavigate();

  return (
    <motion.div
      whileHover={{
        y: -10,
      }}
      transition={{
        duration: 0.25,
      }}
      className="case-study-card-premium"
      onClick={() => navigate(`/case-studies/${study.slug}`)}
    >
      <div className="case-study-header">
        <span>{study.industry}</span>
        <small>{study.timeline}</small>
      </div>

      <div className="case-study-metric">{study.results[0]}</div>

      <h3>{study.client}</h3>

      <p>{study.challenge}</p>

      <div className="case-study-services">
        {study.servicesUsed?.map((service) => (
          <span key={service}>{service}</span>
        ))}
      </div>

      {study.sourceTitle && (
        <div
          style={{
            marginTop: "16px",
            fontSize: ".85rem",
            color: "#64748b",
          }}
        >
          Public reference: {study.sourceTitle}
        </div>
      )}
    </motion.div>
  );
}

export default CaseStudyCard;
